exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden {\n  display: none; }\n\n.display {\n  display: none; }\n\nimg {\n  width: 1rem; }\n\n.noinfo {\n  border-bottom: 1px solid #dddbda; }\n\n.trading-plus {\n  margin-left: -1rem; }\n\n.show-trading {\n  display: '' !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-cash-balance-and-alert/trading-cash-balance-and-alert.component.scss
// module id = ../../../../../src/app/securities-level/trading-cash-balance-and-alert/trading-cash-balance-and-alert.component.scss
// module chunks = main